<div class="form-container">
  
  <form *ngIf="usuarioForm" nz-form nzLayout="vertical" [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
  
        <!-- Form Actions -->
    <nz-form-item class="flex end">
      <button nz-button nzType="primary" [nzLoading]="loading" type="submit" class="excel-button">
        Aceptar
      </button>
    </nz-form-item>
    <!-- RFC Field -->
    <!-- <nz-form-item>
      <nz-form-label nzFor="rfc">RFC</nz-form-label>
      <nz-form-control [nzErrorTip]="rfcErrorTpl">
        <input
          nz-input
          type="text"
          placeholder="Ingrese el RFC"
          formControlName="rfc"
          id="rfc"
          autocomplete="off"
        />
        <ng-template #rfcErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El RFC es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('pattern')">
            El RFC debe tener un formato válido
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item> -->

    <!-- Email Field -->
    <nz-form-item>
      <nz-form-label nzFor="email" class="bold"><div class="bold-title">Email:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="emailErrorTpl">
        <input
          nz-input
          type="email"
          placeholder="Ingrese el email"
          formControlName="email"
          id="email"
          autocomplete="off"
        />
        <ng-template #emailErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El email es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('email')">
            El email debe tener un formato válido
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Rol Select -->
    <nz-form-item>
      <nz-form-label nzFor="rolId" class="bold"><div class="bold-title">Rol:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="rolErrorTpl">
        <nz-select
          formControlName="rolId"
          id="rolId"
          nzPlaceHolder="Seleccione un rol"
          nzAllowClear
        >
          <nz-option
            *ngFor="let rol of roles"
            [nzValue]="rol.id"
            [nzLabel]="rol.descripcion || ''"
          ></nz-option>
        </nz-select>
        <ng-template #rolErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El rol es obligatorio
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Sociedad -->
    <nz-form-item>
      <nz-form-label nzFor="sociedadId"><div class="bold-title">Sociedad:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="sociedadErrorTpl">
        <nz-select
          formControlName="sociedadId"
          id="sociedadId"
          nzPlaceHolder="Seleccione una división"
          nzShowSearch
          nzAllowClear
        >
            <nz-option
              *ngFor="let sociedad of sociedades"
              [nzValue]="sociedad.id"
              [nzLabel]="(sociedad.codigo || '') + ' - ' + (sociedad.descripcion || '')"
              [nzDisabled]="sociedad.divisiones?.length === 0 || sociedad.activo === false"
            ></nz-option>
        </nz-select>
        
        <ng-template #sociedadErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            La sociedad obligatoria
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>


  </form>
</div>